/**
 * MAMAVIBEZ - GLOBAL JAVASCRIPT
 */

function debounce(fn, wait) {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), wait);
  };
}

// Currency Formatter
window.formatMoney = function (cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || window.themeSettings?.moneyFormat || '₹{{amount}}';

  function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
    if (isNaN(number) || number == null) return 0;
    number = (number / 100.0).toFixed(precision);
    const parts = number.split('.');
    const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    const centsPart = parts[1] ? decimal + parts[1] : '';
    return dollars + centsPart;
  }

  switch (formatString.match(placeholderRegex)?.[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    default:
      value = formatWithDelimiters(cents, 2);
  }

  return formatString.replace(placeholderRegex, value);
};

// Global Toast Notification
window.showToast = function (message, duration = 3000) {
  const toast = document.getElementById('NotificationToast');
  if (!toast) return;
  const msgEl = toast.querySelector('.notification-toast__message');
  if (msgEl) msgEl.textContent = message;
  toast.hidden = false;
  setTimeout(() => {
    toast.hidden = true;
  }, duration);
};

// Wishlist Engine
const WISHLIST_KEY = 'mamavibez_wishlist';

function escapeHTML(str) {
  if (!str) return '';
  return String(str).replace(/[&<>'"]/g, 
    tag => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      "'": '&#39;',
      '"': '&quot;'
    }[tag] || tag)
  );
}

window.getWishlist = function() {
  try {
    const raw = localStorage.getItem(WISHLIST_KEY);
    if (!raw) {
      const initial = [{
        id: 'demo-1',
        title: 'Maternity & Feeding Anarkali Dress in Floral Plum',
        price: '₹1,499',
        compare_at_price: '₹2,999',
        image: 'https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?w=400&auto=format&fit=crop&q=80',
        url: '/collections/all',
        variant_id: ''
      }];
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(initial));
      return initial;
    }
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.map((item, idx) => {
      if (typeof item === 'string') {
        return {
          id: item,
          title: 'Maternity & Feeding Comfort Dress',
          price: '₹1,499',
          compare_at_price: '₹2,999',
          image: '',
          url: '/collections/all',
          variant_id: ''
        };
      }
      return item;
    });
  } catch (e) {
    return [];
  }
};

window.saveWishlist = function(list) {
  localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
  window.updateWishlistCount();
  window.renderWishlistDrawer();
};

window.updateWishlistCount = function() {
  const list = window.getWishlist();
  document.querySelectorAll('[data-wishlist-count]').forEach(el => {
    el.textContent = list.length;
  });
};

window.toggleWishlist = function(productData, btnEl) {
  let list = window.getWishlist();
  const idStr = String(productData.id || productData);
  const existingIdx = list.findIndex(item => String(item.id) === idStr);

  if (existingIdx > -1) {
    list.splice(existingIdx, 1);
    document.querySelectorAll(`[data-wishlist-toggle][data-product-id="${idStr}"]`).forEach(b => b.classList.remove('is-active'));
    window.showToast('Removed from Wishlist');
  } else {
    const newItem = {
      id: idStr,
      title: productData.title || 'Maternity & Feeding Dress',
      price: productData.price || '₹1,499',
      compare_at_price: productData.compare || '',
      image: productData.image || '',
      url: productData.url || '/collections/all',
      variant_id: productData.variantId || ''
    };
    list.unshift(newItem);
    document.querySelectorAll(`[data-wishlist-toggle][data-product-id="${idStr}"]`).forEach(b => b.classList.add('is-active'));
    window.showToast('❤️ Saved to Wishlist!');
  }

  window.saveWishlist(list);
};

window.openWishlistDrawer = function() {
  const drawer = document.getElementById('WishlistDrawer');
  if (!drawer) return;
  window.renderWishlistDrawer();
  drawer.classList.add('is-open');
  drawer.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
};

window.closeWishlistDrawer = function() {
  const drawer = document.getElementById('WishlistDrawer');
  if (!drawer) return;
  drawer.classList.remove('is-open');
  drawer.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
};

window.renderWishlistDrawer = function() {
  const list = window.getWishlist();
  const container = document.getElementById('WishlistItemsList');
  const emptyState = document.getElementById('WishlistEmptyState');
  const footer = document.getElementById('WishlistDrawerFooter');

  if (!container || !emptyState) return;

  if (list.length === 0) {
    container.innerHTML = '';
    emptyState.hidden = false;
    if (footer) footer.style.display = 'none';
    return;
  }

  emptyState.hidden = true;
  if (footer) footer.style.display = 'block';

  container.innerHTML = list.map(item => `
    <div class="wishlist-item" data-item-id="${item.id}">
      <a href="${item.url}" class="wishlist-item__media">
        ${item.image ? `<img src="${item.image}" alt="${escapeHTML(item.title)}" loading="lazy">` : `<div class="wishlist-item__placeholder"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><circle cx="8.5" cy="8.5" r="1.5"></circle><polyline points="21 15 16 10 5 21"></polyline></svg></div>`}
      </a>
      <div class="wishlist-item__details">
        <h4 class="wishlist-item__title">
          <a href="${item.url}">${escapeHTML(item.title)}</a>
        </h4>
        <div class="wishlist-item__price-row">
          <span class="wishlist-item__price">${item.price}</span>
          ${item.compare_at_price ? `<s class="wishlist-item__compare">${item.compare_at_price}</s>` : ''}
        </div>
        <div class="wishlist-item__actions">
          <button type="button" class="button button--primary button--sm button--pill wishlist-item__move-cart" data-move-to-cart data-item-id="${item.id}" data-variant-id="${item.variant_id}">
            Move to Cart
          </button>
          <button type="button" class="wishlist-item__remove-btn" data-remove-wishlist data-item-id="${item.id}" aria-label="Remove item">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>
          </button>
        </div>
      </div>
    </div>
  `).join('');
};

window.removeFromWishlist = function(id) {
  let list = window.getWishlist();
  list = list.filter(item => String(item.id) !== String(id));
  document.querySelectorAll(`[data-wishlist-toggle][data-product-id="${id}"]`).forEach(b => b.classList.remove('is-active'));
  window.saveWishlist(list);
  window.showToast('Removed from Wishlist');
};

window.moveWishlistItemToCart = async function(id, variantId) {
  const list = window.getWishlist();
  const item = list.find(it => String(it.id) === String(id));
  const vId = variantId || item?.variant_id;

  if (vId) {
    try {
      const res = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: vId, quantity: 1 })
      });
      if (res.ok) {
        window.removeFromWishlist(id);
        window.closeWishlistDrawer();
        window.showToast('Added to cart!');
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          fetch('/cart.js').then(r => r.json()).then(cart => cartDrawer.renderContents(cart));
          cartDrawer.open();
        } else {
          window.location.href = '/cart';
        }
        return;
      }
    } catch (e) {}
  }

  if (item && item.url) {
    window.location.href = item.url;
  }
};

// Share Button Custom Element
class ShareButton extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('.share-button__button');
    this.label = this.querySelector('.share-button__label');
    this.init();
  }

  init() {
    this.button?.addEventListener('click', async (e) => {
      e.preventDefault();
      const url = window.location.href;
      const title = document.title;

      if (navigator.share) {
        try {
          await navigator.share({
            title: title,
            text: `Take a look at ${title} on MamaVibez:`,
            url: url
          });
          return;
        } catch (err) {
          if (err.name === 'AbortError') return;
        }
      }

      let copied = false;
      if (navigator.clipboard && window.isSecureContext) {
        try {
          await navigator.clipboard.writeText(url);
          copied = true;
        } catch (e) {}
      }

      if (!copied) {
        const textarea = document.createElement('textarea');
        textarea.value = url;
        textarea.style.position = 'fixed';
        textarea.style.left = '-9999px';
        document.body.appendChild(textarea);
        textarea.select();
        try {
          document.execCommand('copy');
          copied = true;
        } catch (e) {}
        document.body.removeChild(textarea);
      }

      if (window.showToast) {
        window.showToast('🔗 Product link copied to clipboard!');
      }

      if (this.label) {
        const orig = this.label.textContent;
        this.label.textContent = 'Copied!';
        setTimeout(() => {
          this.label.textContent = orig;
        }, 2500);
      }
    });
  }
}

if (!customElements.get('share-button')) {
  customElements.define('share-button', ShareButton);
}

document.addEventListener('DOMContentLoaded', () => {
  window.updateWishlistCount();

  // Wishlist Drawer Triggers
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-wishlist-open]')) {
      e.preventDefault();
      window.openWishlistDrawer();
      return;
    }
    if (e.target.closest('[data-wishlist-close]')) {
      e.preventDefault();
      window.closeWishlistDrawer();
      return;
    }
    const removeWishlistBtn = e.target.closest('[data-remove-wishlist]');
    if (removeWishlistBtn) {
      e.preventDefault();
      const id = removeWishlistBtn.dataset.itemId;
      window.removeFromWishlist(id);
      return;
    }
    const moveCartBtn = e.target.closest('[data-move-to-cart]');
    if (moveCartBtn) {
      e.preventDefault();
      const id = moveCartBtn.dataset.itemId;
      const vId = moveCartBtn.dataset.variantId;
      window.moveWishlistItemToCart(id, vId);
      return;
    }
    if (e.target.closest('#ClearAllWishlistBtn')) {
      e.preventDefault();
      window.saveWishlist([]);
      window.showToast('Wishlist cleared');
      return;
    }
  });

  // Initialize wishlist toggle buttons on cards & PDP
  const wishlist = window.getWishlist();
  const wishIds = wishlist.map(i => String(i.id));

  document.querySelectorAll('[data-wishlist-toggle]').forEach(btn => {
    const pId = btn.dataset.productId;
    if (wishIds.includes(String(pId))) {
      btn.classList.add('is-active');
    }
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const pData = {
        id: btn.dataset.productId,
        title: btn.dataset.productTitle,
        price: btn.dataset.productPrice,
        compare: btn.dataset.productCompare,
        image: btn.dataset.productImage,
        url: btn.dataset.productUrl,
        variantId: btn.dataset.variantId
      };
      window.toggleWishlist(pData, btn);
    });
  });

  // Mobile Navigation Drawer
  const menuToggle = document.querySelector('[data-mobile-menu-toggle]');
  const menuDrawer = document.getElementById('MobileMenuDrawer');
  const menuClose = document.querySelector('[data-mobile-menu-close]');

  if (menuToggle && menuDrawer) {
    menuToggle.addEventListener('click', () => {
      menuDrawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });

    const closeDrawer = () => {
      menuDrawer.classList.remove('is-open');
      document.body.style.overflow = '';
    };

    if (menuClose) menuClose.addEventListener('click', closeDrawer);
    menuDrawer.querySelector('.mobile-menu__backdrop')?.addEventListener('click', closeDrawer);
  }

  // Modals Controller
  document.querySelectorAll('[data-modal-trigger]').forEach((trigger) => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      const targetId = trigger.getAttribute('data-modal-target');
      const modal = document.getElementById(targetId);
      if (modal) {
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
      }
    });
  });

  document.querySelectorAll('[data-modal-close]').forEach((closer) => {
    closer.addEventListener('click', () => {
      const modal = closer.closest('.modal-dialog');
      if (modal) {
        modal.hidden = true;
        document.body.style.overflow = '';
      }
    });
  });

  // Escape key handler
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      document.querySelectorAll('.modal-dialog:not([hidden])').forEach((modal) => {
        modal.hidden = true;
      });
      document.querySelector('.cart-drawer.is-open')?.classList.remove('is-open');
      document.querySelector('.predictive-search-modal.is-open')?.classList.remove('is-open');
      document.getElementById('MobileMenuDrawer')?.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  });

  // Pincode Delivery Estimator
  const pincodeBtn = document.getElementById('PincodeCheckBtn');
  const pincodeInput = document.getElementById('PincodeInput');
  const pincodeResult = document.getElementById('PincodeResult');

  if (pincodeBtn && pincodeInput && pincodeResult) {
    pincodeBtn.addEventListener('click', () => {
      const val = pincodeInput.value.trim();
      if (/^\d{6}$/.test(val)) {
        // Calculate estimated delivery 4 days ahead
        const estDate = new Date();
        estDate.setDate(estDate.getDate() + 4);
        const options = { weekday: 'short', month: 'short', day: 'numeric' };
        const dateStr = estDate.toLocaleDateString('en-IN', options);

        pincodeResult.innerHTML = `
          <div class="pincode-success">
            <p><strong>🚚 Free Delivery by ${dateStr}</strong></p>
            <p class="caption" style="color: #038D63; font-weight: 600;">Cash on Delivery (COD) Available | 7 Days Returnable</p>
          </div>
        `;
        pincodeResult.hidden = false;
      } else {
        pincodeResult.innerHTML = `<p style="color: #C62828; font-size: 1.3rem;">Please enter a valid 6-digit Indian PIN code.</p>`;
        pincodeResult.hidden = false;
      }
    });
  }
});
